import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(planChangeOnEnterSaga);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, select } from 'redux-saga/effects';
import { userProfile, planById } from 'redux/saga/entities/bound';
import { isLoggedIn } from 'redux/saga/selectors';
import loginRedirectUrl from 'helpers/loginRedirectUrl';
import { memberStatus } from 'enums/memberStatus';
import Base64Deriver from 'derivers/Base64';
export function planChangeOnEnterSaga(client, nextState, replaceState) {
  var planId, plan, profile;
  return regeneratorRuntime.wrap(function planChangeOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          planId = Base64Deriver.decodeNumber(nextState.params.encodedId);
          _context.next = 3;
          return call(fetchEntityIfNeeded, planById, [client, planId]);

        case 3:
          plan = _context.sent;

          if (plan.enabled) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return call(replaceState, '/');

        case 7:
          _context.next = 23;
          break;

        case 9:
          _context.next = 11;
          return select(isLoggedIn);

        case 11:
          if (_context.sent) {
            _context.next = 16;
            break;
          }

          _context.next = 14;
          return call(replaceState, loginRedirectUrl(nextState.location));

        case 14:
          _context.next = 23;
          break;

        case 16:
          _context.next = 18;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 18:
          profile = _context.sent;

          if (!memberStatus('UNSUBSCRIBED', profile && profile.membership && profile.membership.status)) {
            _context.next = 23;
            break;
          }

          _context.next = 22;
          return call(replaceState, '/');

        case 22:
          return _context.abrupt("return", _context.sent);

        case 23:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}